export const REASON_CODES = [
  { label: 'Bot behavior', value: 'BOT_BEHAVIOR' },
  { label: 'Prank calls', value: 'PRANK_CALL' },
  { label: 'Severity 1', value: 'SEVERITY_1' },
  { label: 'Severity 2', value: 'SEVERITY_2' },
];

export const BLOCK_END_OPTIONS = [
  { label: '3 days', value: '3_DAYS' },
  { label: 'Permanent', value: 'PERMANENT' },
];
